import React from "react";
import Loader from "../../../../assets/img/loader.gif";

const Modal = ({
  isOpen,
  onClose,
  isActive,
  onToggle,
  activateRef,
  confirmLoader,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className="w-96 rounded-xl bg-navy-800 p-6 shadow-lg"
        ref={activateRef}
      >
        <h2 className="mb-4 text-xl font-bold text-white">Confirm Action</h2>
        <p className="mb-6 text-gray-300">
          Are you sure you want to {isActive ? "deactivate" : "activate"} this
          user?
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="rounded-md bg-gray-600 px-4 py-2 text-white hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onToggle();
            }}
            className="w-24 rounded-md bg-primary-gradient px-4 py-2 text-white hover:opacity-90"
          >
            {confirmLoader ? (
              <img src={Loader} alt="Loading..." className="mx-auto h-6 w-6" />
            ) : (
              "Confirm"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
